////////LIBRARY/////////
import React from 'react'
import styled from 'styled-components'
import { isEmpty, map } from 'lodash'
import { useSelector, shallowEqual } from 'react-redux'

//////STYLED//////
const InitKioskCustomerRequestActionWrapper = styled.div`
	max-width: 200px;
`
//////STYLED//////

const InitKioskCustomerRequestAction = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	let lstRequests = props.row.requiredAction

	if (!isEmpty(props.row.requiredAction)) {
		lstRequests = map(props.row.requiredAction, (elem) => {
			return translations[elem]
		})
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return <InitKioskCustomerRequestActionWrapper>{!isEmpty(lstRequests) ? lstRequests.join(', ') : '-'}</InitKioskCustomerRequestActionWrapper>
}

InitKioskCustomerRequestAction.propTypes = {}

InitKioskCustomerRequestAction.defaultPropTypes = {}

export default InitKioskCustomerRequestAction
